export default {
  brand: 'CryptoPay',
  transferHint: '以下のアドレスへ送金してください',
  rechargeAmount: '入金額',
  rechargeAddress: '入金アドレス',
  scanTip: 'ウォレットでQRコードをスキャンして送金してください',
  copy: 'コピー',
  copied: 'コピーしました',
  copyFail: 'コピーに失敗しました',
  networkFee: 'ネットワーク手数料',
  eta: '着金予定時間',
  etaVal: '5〜15分',
  actualArrival: '実際の着金額',
  noticeTitle: '入金に関する注意事項',
  notice1: '必ずこのページに表示されているQRコードまたはアドレスにのみ送金してください。誤ったアドレスへの送金資産は回収できません。',
  notice2: '送金額は必ず {amount} {coin} と正確に一致している必要があります。金額が異なる場合、自動入金されません。',
  notice3: 'ブロックチェーンの承認をお待ちください。（通常は1回の承認後に自動で着金します）',
  notice4: 'ブロックチェーン上の送金は取り消しできません。利用者の操作ミスによる損失は利用者自身の責任となります。',
  selectLang: '言語を選択',
  back: '戻る',
  pending: '支払い待ち',
  paid: '支払い済み',
  timeout: '期限切れ',
  orderNo: '注文番号',
  loading: '読み込み中…',
  paramError: 'リンクパラメータが不完全です',
  initFail: '注文の作成に失敗しました',
  paidSuccess: '支払いが完了しました',
  timedOut: '注文の有効期限が切れました。再度お試しください'
}